import { Component, Input, OnInit, ViewChild, ElementRef, SimpleChanges, SimpleChange, OnChanges, AfterViewInit, ViewEncapsulation, OnDestroy, TemplateRef } from '@angular/core';
import { WindowService, DialogService, DialogRef } from '@progress/kendo-angular-dialog';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { FlowActionsComponent } from '../flow-actions/flow-actions.component';
import { Flow } from '../obj/Flow';
import { FlowRun } from '../obj/FlowRun';
import { FlowRunAction } from "../obj/FlowRunAction";
import { FlowManagementService } from '../services/flow-management.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
//import { AnalyticsService } from '../services/analytics.service';
import { FlowEventService, FlowEvent } from '../services/flow-event.service';
import { Observable, BehaviorSubject, combineLatest, interval, Subscription } from 'rxjs';
import { PaymentService } from '../services/payment.service';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
//import { setTime } from '@progress/kendo-angular-dateinputs/dist/es2015/util';
import { ApplicationInsightsService } from '../services/application-insights.service';
import { GanttComponent } from './gantt.component';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { map } from 'rxjs/operators';
import { TimelineComponent } from './timeline.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { StorageRouterService } from '../services/storage-router.service';

@Component({
    selector: 'app-flow-runs',
    templateUrl: './flow-runs.component.html',
    styleUrls: ['./flow-runs.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class FlowRunsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  state: State = {
    skip: 0,
    take: 50,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  view$: Observable<GridDataResult>;
  state$: BehaviorSubject<State> = new BehaviorSubject(this.state);

  protected runs$ = new BehaviorSubject<FlowRun[]>([]);

  /** Free-text search bound to the toolbar input. Filters by name / status /
   *  trigger fields before the Kendo grid filter runs. */
  public search = '';
  private search$ = new BehaviorSubject<string>('');

  /** "Get More Runs" CDK overlay menu — mirrors the top-nav environment /
   *  user menus so the dropdown panel is visually identical. */
  public moreRunsMenuOpen = false;
  public dropdownPositionsLeft: ConnectedPosition[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  ];

  @Input()
  runs: FlowRun[];

  @Input()
  nested: boolean = false;

  // @Input()
  // public environment: string;
  apiRoot: string = "https://flow.microsoft.com";


  // @Input()
  // public flowName: string;
  @Input()
  public flow: Flow;
  @Input()
  public admin: boolean = false;
  @Input()
  public deep: boolean = false;
  @Input()
  public more: boolean = false;
  @Input()
  public status: string = '';

  public selection: string[] = [];
  error: string = null;
  private routedPage = false;

  private subscription = new Subscription();

  @ViewChild('rungrid', {static: true}) rungrid;
  @ViewChild('confirmTemplate') confirmTemplate: TemplateRef<any>;
  confirmMessage: string = '';
  private _confirmResolve: ((v: boolean) => void) | null = null;
  private _confirmDialogRef: DialogRef | null = null;
  loading$= new BehaviorSubject(false);
  pages = [
    { text: "Get Next 50 Runs", click: () => { this.getRuns(false, this.admin, 1) } },
    { text: "Get Next 100 Runs", click: () => { this.getRuns(false, this.admin, 2) } },
    // { text: "Get 3", click: () => { this.getRuns(false, this.admin, 3) } },
    // { text: "4", click: () => { this.getRuns(false, this.admin, 4) } },
    { text: "Get Next 250 Runs", click: () => { this.getRuns(false, this.admin, 5) } },
    { text: "Get Next 500 Runs", click: () => { this.getRuns(false, this.admin, 10) } },
    { text: "Get Next 1000 Runs", click: () => { this.getRuns(false, this.admin, 20) } },
    { text: "Get Next 2000 Runs", click: () => { this.getRuns(false, this.admin, 40) } },
  ];

  constructor(
    protected flowManagementService: FlowManagementService,
    private windowService: WindowService,
    private dialogService: DialogService,
    //private analytics: AnalyticsService,
    private appInsights: ApplicationInsightsService,
    private flowEventService: FlowEventService,
    private paymentService: PaymentService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private storageService: StorageRouterService,
    private router: Router,
  ) {
    this.allData = this.allData.bind(this);

    this.view$ = combineLatest([this.runs$, this.state$, this.search$]).pipe(map(([runs, state, search])=>{
      const filtered = this.applySearch(runs, search);
      const d = process(filtered, state);
      return d;
    }));
    this.subscription.add(
      this.view$.subscribe()
    );
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.state$.next(this.state);
    //this.view = process(this.runs$.getValue(), this.state);
  }

  ngOnInit() {

    //interval(1).toPromise().then(()=>{
    // setTimeout(()=>{
    if (this.nested) {
      return;
    }

    if (this.status) {
      this.state = {
        filter: {
          filters: [{
            "field": "status",
            "operator": "contains",
            "value": this.status
          }],
          logic: "or"
        }
      };
      this.state$.next(this.state);
    }

    if (false && this.flow?.runsCount > 0) {

      let promises = [];
      // grab trigger input

      let p = new Promise((resolve) => {
        setTimeout(()=>{
          this.loading$.next(true);
          this.flowManagementService.serviceStatus$.next(`reading trigger history (${this.flow.runs.length})...`);
          resolve(true);
        }, 100);
      });
      promises.push(p);

      this.flow.runs.forEach(run => {
        if (run.triggerData) {
          return;
        }
        var p = this.flowManagementService.getFlowRunTrigger(run).then(triggerOutput => {
          run.triggerData = triggerOutput;
          run.error = null;
        }).catch(reason=>{
          run.error = reason;
          return null;
        });
        promises.push(p);
      })

      Promise.all(promises).then(()=>{
        this.refreshRunGrid();
      });

      return;
    }

    if (this.flow) {
      // Stream cached runs into the grid immediately so a deep-link to
      // ?tab=runs paints from cache before the network call lands. The
      // fresh fetch (getRuns) merges/replaces as new data arrives.
      this.wireCachedRuns(this.flow.environment, this.flow.flowName);
      setTimeout(() => {
        //debugger;
        this.getRuns(this.deep, this.admin, (this.more?1:0) );
      }, 100);
    }
    else {
      this.loadFromRoute();
    }
  }

  /**
   * Subscribe to the storage runs stream filtered to the given flow so the
   * grid renders cached runs the moment the page mounts. Stays subscribed for
   * the component's lifetime so any later cache write (fresh fetch landing,
   * other tab updating runs) re-renders in place.
   */
  private wireCachedRuns(envName: string, flowName: string): void {
    if (!envName || !flowName) return;
    this.subscription.add(
      this.storageService.getRuns$(envName).subscribe((cached) => {
        const flowRuns = (cached || []).filter((r) => r.flowName === flowName);
        if (flowRuns.length === 0) return;
        this.runs$.next(flowRuns);
        this.refreshRunGrid();
      })
    );
  }

  /** Toolbar search-box handler — fires on every keystroke. */
  public onSearchChange(value: string): void {
    this.search = value || '';
    this.search$.next(this.search);
  }

  /** Toggle the "Get More Runs" dropdown menu. */
  public toggleMoreRunsMenu(): void {
    this.moreRunsMenuOpen = !this.moreRunsMenuOpen;
  }

  /** Close the "Get More Runs" dropdown menu (backdrop click / detach). */
  public closeMoreRunsMenu(): void {
    this.moreRunsMenuOpen = false;
  }

  /** Fired when an item in the "Get More Runs" dropdown is clicked. */
  public onMoreRunsClick(page: { click: () => void }): void {
    this.moreRunsMenuOpen = false;
    page?.click?.();
  }

  /** Free-text filter applied before the Kendo grid's column filters. Matches
   *  on name, status, trigger name / text / value (case-insensitive). */
  private applySearch(runs: FlowRun[], search: string): FlowRun[] {
    const q = (search || '').trim().toLowerCase();
    if (!q) return runs;
    return runs.filter((r) =>
      (r.name || '').toLowerCase().includes(q) ||
      (r.status || '').toLowerCase().includes(q) ||
      (r.triggerName || '').toLowerCase().includes(q) ||
      (r.triggerText || '').toLowerCase().includes(q) ||
      (r.triggerValue != null ? String(r.triggerValue).toLowerCase().includes(q) : false)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async getRuns(deep: boolean = false, admin: boolean = false, page:number = 1) {

    this.loading$.next(true);

    const runsPromise = this.routedPage
      ? this.flowManagementService.getFlowRunsForRoute(this.flow.environment, this.flow.flowName, admin)
      : this.flowManagementService.getFlowRuns(this.flow, deep, true, admin, page);

    const merge = (runs:FlowRun[], new_runs:FlowRun[]) => {
      return new_runs.reduce((result, current)=>{
          if (undefined == result.find((run)=>run.name == current.name)) {
            result.push(current);
          }
          return result;
      }, runs);
    };

    await runsPromise.then((runs)=>{

      const _runs = merge(this.runs$.getValue(), runs);
      this.runs$.next(_runs);
      this.refreshRunGrid();

    }).catch(reason=>{
      this.error = reason;
    });
  }

  private async loadFromRoute() {
    const envName = this.route.snapshot.paramMap.get('envName') || '';
    const flowName = this.route.snapshot.paramMap.get('flowName') || '';
    if (!envName || !flowName) {
      this.error = 'Missing flow route parameters.';
      return;
    }

    this.routedPage = true;
    this.admin = `${this.route.snapshot.queryParamMap.get('admin') || ''}`.toLowerCase() === 'true';
    this.deep = `${this.route.snapshot.queryParamMap.get('deep') || ''}`.toLowerCase() === 'true';
    this.status = this.route.snapshot.queryParamMap.get('status') || '';

    if (this.status) {
      this.state = {
        filter: {
          filters: [{
            field: 'status',
            operator: 'contains',
            value: this.status
          }],
          logic: 'or'
        }
      };
      this.state$.next(this.state);
    }

    // Start streaming cached runs to the grid immediately — runs from cache
    // typically resolve before the cached-flow read finishes, so the user
    // sees rows the moment the page mounts.
    this.wireCachedRuns(envName, flowName);

    const cached = [
      ...await this.storageService.getFlows(),
      ...await this.storageService.getFlowsAdmin()
    ].find((flow: Flow) => flow.environment === envName && flow.flowName === flowName);

    this.flow = cached || Object.assign(new Flow(), {
      environment: envName,
      flowName,
      displayName: flowName,
      flowState: 'Started',
      runs: []
    });

    await this.getRuns(this.deep, this.admin, 0);
  }

  async refetchErrorRuns() {

    const runs = this.runs$.getValue().filter((run)=>run.error || !run.triggerData );
    let promises = [];

    runs.forEach(run => {
      if (run.triggerData) {
        return;
      }
      var p = this.flowManagementService.getFlowRunTrigger(run).then(triggerOutput => {
        run.triggerData = triggerOutput;
        run.error = null;
      }).catch(reason=>{
        run.error = reason;
        return null;
      });
      promises.push(p);
    })

    return Promise.all(promises).then(()=>{
      this.refreshRunGrid();
    });
  }

  refreshRunGrid() {
    // this.runs = this.flow.runsLoaded;
    //this.state.take = this.runs.length;
    // this.view = process(this.runs$.getValue(), this.state);
    this.flowManagementService.serviceStatus$.next("");
    this.loading$.next(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    const runs: SimpleChange = changes.runs;
    if (runs && runs.currentValue != runs.previousValue) {
      this.runs$.next(runs.currentValue);
      this.refreshRunGrid();
    }
    // const flow: SimpleChange = changes.flow;
    // if (flow && flow.currentValue != flow.previousValue) {
    //     this.runs = flow.currentValue.runs;
    //     this.refreshRunGrid();
    // }
  }

  ngAfterViewInit() {
  }

  public async onSelect({ dataItem, item }): Promise<void> {

    //this.analytics.send("runs", item);
    //this.appInsights.logPageView(`runs: ${item}`);
    this.appInsights.trackEvent(`runs`, { "select": item });

    switch (item) {
      case "Get Latest Runs": {

        this.deep = false;
        this.flowManagementService.getFlowRuns(this.flow, this.deep, true, this.admin).then(() => {
          this.refreshRunGrid();
        });

        break;
      }
      case "Get More Runs":
      case "Get More Runs (slow)":

        this.doMoreRuns();
        break;
      case "Get All Runs (slow)":
        this.doAllRuns();
        break;
      case "Resubmit": {
        const targets = this.selection.length
          ? this.runs$.getValue().filter(r => this.selection.includes(r.name))
          : [dataItem];
        const confirmed = await this.confirmAction(
          `Resubmit ${targets.length} run${targets.length > 1 ? 's' : ''}?`,
          `This will resubmit ${targets.length > 1 ? targets.length + ' runs' : '1 run'}. Continue?`
        );
        if (!confirmed) break;
        await Promise.all(targets.map(r => this.flowManagementService.resubmit(r).toPromise()))
          .then(() => this.flowManagementService.getFlowRuns(this.flow, this.deep, true, this.admin))
          .then(() => this.refreshRunGrid())
          .catch(reason => { this.error = reason; });
        break;
      }
      case "Cancel": {
        const targets = this.selection.length
          ? this.runs$.getValue().filter(r => this.selection.includes(r.name))
          : [dataItem];
        const confirmed = await this.confirmAction(
          `Cancel ${targets.length} run${targets.length > 1 ? 's' : ''}?`,
          `This will cancel ${targets.length > 1 ? targets.length + ' runs' : '1 run'}. Continue?`
        );
        if (!confirmed) break;
        await Promise.all(targets.map(r => this.flowManagementService.cancelFlowRun(r).toPromise()))
          .then(() => this.flowManagementService.getFlowRuns(this.flow, this.deep, true, this.admin))
          .then(() => this.refreshRunGrid())
          .catch(reason => { this.error = reason; });
        break;
      }
      case "Delete": {
        var promises = [];
        if (this.selection.length) {
          for (var i = 0; i < this.selection.length; i++) {
            var run = this.runs$.getValue().find(r => r.name == this.selection[i]);

            //console.log(run.name);
            var p = this.flowManagementService.deleteFlowRun(run).toPromise();
            promises.push(p);
          }
        }
        else {
          var p = this.flowManagementService.deleteFlowRun(dataItem).toPromise();
          promises.push(p);
        }

        Promise.all(promises).then(() => {
          return this.flowManagementService.getFlowRuns(this.flow, this.deep, true, this.admin);
        }).then(() => {
          this.refreshRunGrid();
        }, ()=> {
          this.flowManagementService.serviceStatus$.next('Delete run failed - the preview API is not active in your tenant yet.');
        });
        break;
      }
      case "List Run Actions": {
        this.flowManagementService.getFlowRun(dataItem).toPromise().then((actions: FlowRunAction[]) => {

          //var rows = actions.map( (action)=> `<tr><td>${action.name}</td><td>${action.status}</td><td>${action.code}</td><td>${action.error}</td><td>${action.startTime}</td><td>${action.endTime}</td></tr>`).join('')

          var windowRef = this.windowService.open({
            content: FlowActionsComponent,
            title: "Run Actions",
            height: 800,
            resizable: true,
            draggable: true,
            keepContent: false
          });
          var flowActions: FlowActionsComponent = windowRef.content.instance;
          flowActions.actions = actions;

        });
        break;
      }
      case "Run Gantt": {
        this.flowManagementService.getFlowRun(dataItem).toPromise().then((actions: FlowRunAction[]) => {

          //var rows = actions.map( (action)=> `<tr><td>${action.name}</td><td>${action.status}</td><td>${action.code}</td><td>${action.error}</td><td>${action.startTime}</td><td>${action.endTime}</td></tr>`).join('')

          var windowRef = this.windowService.open({
            content: GanttComponent,
            title: "Run Gantt",
            height: 800,
            width: 600,
            state: "maximized",
            minWidth: 250,
            resizable: true,
            draggable: true,
            keepContent: false
          });
          var runGantt: GanttComponent = windowRef.content.instance;
          runGantt.actions = actions;

        });
        break;
      }
      case "Run Timeline": {
        this.flowManagementService.getFlowRunTimeline(dataItem).then((actions: FlowRunAction[]) => {

          // var windowRef = this.windowService.open({
          //   content: TimelineComponent,
          //   title: "Run Timeline",
          //   height: 800,
          //   width: 600,
          //   state: "maximized",
          //   minWidth: 250,
          //   resizable: true,
          //   draggable: true,
          //   keepContent: false
          // });
          // var runTimeline: TimelineComponent = windowRef.content.instance;
          // runTimeline.actions = actions;
          var windowRef = this.windowService.open({
            content: FlowActionsComponent,
            title: "Run Actions",
            height: 800,
            resizable: true,
            draggable: true,
            keepContent: false
          });
          var flowActions: FlowActionsComponent = windowRef.content.instance;
          flowActions.actions = actions;

        })
        break;
      }
      case "Export Excel": {
        //this.rungrid.saveAsExcel();
        this.doExcel();
        break;
      }
      default:
        break;
    }
  }

  async doMoreRuns() {
    var status = await this.paymentService.checkSubscription();
    if (!status) return;

    if (this.nested) {
      // Nested view (embedded as a sub-component) — pop out to the dedicated
      // /runs route instead of the legacy tab-strip so the user gets the full
      // page with its own toolbar, search, and pagination.
      this.navigateToRunsPage();
      return;
    }

    //this.flow.runs = [];
    this.flowManagementService.getFlowRuns(this.flow, this.deep, true, this.admin, 1).then(() => {
      this.refreshRunGrid();
    });
  }

  async doAllRuns() {
    var status = await this.paymentService.checkSubscription();
    if (!status) return;

    //this.flow.runs = [];
    this.deep = true;
    if (this.nested) {
      // Nested view — pop out to /runs with deep=true. The route page reads
      // ?deep from the query and applies it to its fetch.
      this.navigateToRunsPage({ deep: 'true' });
      return;
    }

    this.flowManagementService.getFlowRuns(this.flow, this.deep, true, this.admin).then(() => {
      this.refreshRunGrid();
    });
  }

  /** Navigate to /flows/:env/:name/runs preserving admin/deep query state. */
  private navigateToRunsPage(extra: Record<string, string> = {}): void {
    if (!this.flow?.environment || !this.flow?.flowName) return;
    const queryParams: Record<string, string> = {
      ...(this.admin ? { admin: 'true' } : {}),
      ...extra,
    };
    this.router.navigate(
      ['/flows', this.flow.environment, this.flow.flowName, 'runs'],
      Object.keys(queryParams).length ? { queryParams } : {}
    );
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.runs$.getValue(), {
        skip: 0,
        take: this.runs$.getValue().length,
        sort: this.state.sort
      }).data,
    };
    return result;
  }

  public async doExcel() {
    // var status = await this.paymentService.checkSubscription();
    // if (!status) return;

    this.rungrid.saveAsExcel();
  }

  get filteredRunsCount(): number {
    return this.getFilteredRuns().length;
  }

  private getFilteredRuns(): FlowRun[] {
    const searched = this.applySearch(this.runs$.getValue(), this.search);
    return process(searched, { filter: this.state.filter }).data as FlowRun[];
  }

  public selectAll(): void {
    this.selection = this.getFilteredRuns().map(r => r.name);
  }

  public clearSelection(): void {
    this.selection = [];
  }

  private async confirmAction(title: string, message: string): Promise<boolean> {
    this.confirmMessage = message;
    return new Promise<boolean>(resolve => {
      this._confirmResolve = resolve;
      this._confirmDialogRef = this.dialogService.open({
        title,
        content: this.confirmTemplate,
        width: 400,
        minWidth: 250
      });
      this._confirmDialogRef.result.subscribe(() => {
        if (this._confirmResolve) {
          this._confirmResolve(false);
          this._confirmResolve = null;
        }
      });
    });
  }

  public resolveConfirm(value: boolean): void {
    const resolve = this._confirmResolve;
    this._confirmResolve = null;
    this._confirmDialogRef?.close();
    this._confirmDialogRef = null;
    resolve?.(value);
  }

  public isAllFilteredSelected(): boolean {
    const filtered = this.getFilteredRuns();
    return filtered.length > 0 && filtered.every(r => this.selection.includes(r.name));
  }

  public isSomeFilteredSelected(): boolean {
    const filtered = this.getFilteredRuns();
    return !this.isAllFilteredSelected() && filtered.some(r => this.selection.includes(r.name));
  }

  public onSelectAllChange(event: Event): void {
    if ((event.target as HTMLInputElement).checked) {
      this.selectAll();
    } else {
      this.clearSelection();
    }
  }

  public over(run: FlowRun /*, span: ElementRef, kendoTooltipInstance: TooltipDirective */) {
    if (run.triggerData) {
      //kendoTooltipInstance.toggle(span, true);
      //kendoTooltipInstance.show(span);
      return;
    }
    // this.flowManagementService.getFlowRunTrigger(run).then((triggerOutput:any)=>{
    //   run.triggerData = triggerOutput;
    //   //kendoTooltipInstance.show(span);
    // });
  }

  // public out(span: ElementRef, kendoTooltipInstance: TooltipDirective){
  //   kendoTooltipInstance.hide();
  // }
  getSafeUrl(url): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


  close() {
    // if (this.windowRef) {
    //     this.windowRef.close();
    // }
    this.flowEventService.closeTabWindow$.emit({
      value: false,
      type: "app-flow-runs",
      flow: this.flow
    });
  }

  public test(pattern, text) {
    return (new RegExp(pattern,'gi')).test(text);
  }

  clearFilter() {
    //this.search$.next('');
    var state : any = this.state;
    state.filter.filters = [];
    this.dataStateChange(state);
  }

  hasFilter$ = this.state$.pipe(map((value)=>{
    const state = value;
    let hasFilter = false;
    try {
        hasFilter = state.filter.filters.length > 0 /* || !!search */;
    }
    catch(e){
        // nothing.
    }
    return hasFilter;
  }));

}
